import React from 'react';
import {Link} from 'react-router-dom'
import {useSelector} from 'react-redux';
import {useLocation} from "react-router-dom";
import './FooterNav.css';

export default function FooterNav() {
    const location = useLocation();
    const role = useSelector((state) => state.userdata?.role);

    // Функция для проверки активного пути
    const isActive = (path) => {
        return location.pathname === path;
    }

    return(
        <div className='main-footerNav'>
        {!role && <p>Автоматика для орошения. Cервис © 2023. Все права защищены.</p>}
        {role===2 && <p>Автоматика для орошения</p>}
        {role===1 &&   
         <div className='footerNav'> 
            <Link to='/devices' className={`navLink ${isActive('/devices') ? 'active' : ''}`}>Все устройства</Link>
            <Link to='/imeis' className={`navLink ${isActive('/imeis') ? 'active' : ''}`}>IMEI</Link>
            <Link to='/users' className={`navLink ${isActive('/users') ? 'active' : ''}`}>Пользователи</Link>
        </div>
        }
        </div> 
    )
}

